/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import Icon from './Icon';
import { createCookie } from '../utils/cookies-browser';
import { setPublicAssetsStatus } from '../actions/actionsSet/userConfig';


const SwitchBox = styled.button`
  background: none;
  outline: none;
  vertical-align: middle;
  width: 36px;
  height: 20px;
  line-height: 18px;
  border-radius: 12px;
  cursor: pointer;
  border: ${({ shouldBorder }) => shouldBorder ? '1px solid #eaecef' : 'none'};
  padding-top: 0;
  padding-bottom: 0;
`;


export type Props = {
  status: boolean,
  shouldBorder: boolean,
  setPublicAssetsStatus: Function,
  buttonId: string,
};


export default
@connect(
  null,
  { setPublicAssetsStatus }
)
class ThemeSwitch extends React.PureComponent<Props> {
  static defaultProps = {
    status: true,
    shouldBorder: true,
    setPublicAssetsStatus: () => { },
  };

  _handleClick = (ev: MouseEvent) => {
    ev.preventDefault();
    const { status } = this.props;
    const shouldPublicAssets = !status;
    createCookie('shouldPublicAssets', shouldPublicAssets);
    this.props.setPublicAssetsStatus(shouldPublicAssets);
  };

  render() {
    const { status, shouldBorder, buttonId } = this.props;
    return (
      <SwitchBox id={buttonId} onClick={this._handleClick} shouldBorder={shouldBorder} className="switch-btn">
        <Icon
          type={status ? 'attention' : 'attention-forbid'}
          size={shouldBorder ? 12 : 16}
        />
      </SwitchBox>
    );
  }
}
